import { render, staticRenderFns } from "./ParticipationInfo.vue?vue&type=template&id=4013844b&scoped=true"
import script from "./ParticipationInfo.vue?vue&type=script&lang=js"
export * from "./ParticipationInfo.vue?vue&type=script&lang=js"
import style0 from "./ParticipationInfo.vue?vue&type=style&index=0&id=4013844b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013844b",
  null
  
)

export default component.exports